import type { SessionUser } from "./sessionTypes.js";
import { InMemoryWsAuthAdapter } from "./wsAuthAdapter.js";

let verifiedUser: SessionUser | null = null;

/** Document-local identity established only by a successful server response. */
export function rememberVerifiedUser(user: SessionUser): void {
  verifiedUser = user;
}

export function currentVerifiedUser(): SessionUser | null {
  return verifiedUser;
}

export function clearVerifiedUser(): void {
  verifiedUser = null;
}

/** Transitional optional TypeAuth credential; never persisted. */
export const browserWsAuth = new InMemoryWsAuthAdapter();
